import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { EmptyRow, PageHeader, Panel } from "@/components/common";
import { Button } from "@/components/ui/button";

export default function AdminContacts() {
  const { t, locale } = useLang();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/contact-requests").then((r) => setRows(r.data)); }, []);
  const toggle = async (r) => {
    try {
      const { data } = await api.patch(`/admin/contact-requests/${r.id}`, { status: r.status === "new" ? "handled" : "new" });
      setRows(rows.map((x) => (x.id === data.id ? data : x)));
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="admin-contacts-page">
      <PageHeader title={t("contactRequests")} subtitle={t("contactRequestsSubtitle")} />
      <Panel className="overflow-x-auto">
        <table className="data-table">
          <thead><tr><th>{t("date")}</th><th>{t("name")}</th><th>{t("company")}</th><th>{t("message")}</th><th>{t("status")}</th><th className="text-end">{t("actions")}</th></tr></thead>
          <tbody>
            {rows.length === 0 && <EmptyRow cols={6} />}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`contact-row-${r.id}`}>
                <td className="whitespace-nowrap">{new Date(r.created_at).toLocaleDateString(locale)}</td>
                <td><div className="font-semibold">{r.name}</div><a href={`mailto:${r.email}`} className="text-xs text-[#007A3D]">{r.email}</a>{r.phone && <div className="text-xs text-slate-400">{r.phone}</div>}</td>
                <td>{r.company || "—"}</td>
                <td className="max-w-md whitespace-pre-wrap text-sm">{r.message}</td>
                <td><span data-testid={`contact-status-${r.id}`} className={`rounded px-2 py-0.5 text-xs font-semibold ${r.status === "new" ? "bg-amber-100 text-amber-800" : "bg-emerald-100 text-emerald-800"}`}>{t(`cr_${r.status}`)}</span></td>
                <td className="text-end"><Button data-testid={`contact-toggle-${r.id}`} size="sm" variant="outline" onClick={() => toggle(r)}>{t(r.status === "new" ? "markHandled" : "markNew")}</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
